import dompurify from 'dompurify';
// cherry-pick lodash methods (the right way). DO NOT use import from 'lodash'.
import isString from 'lodash/isString';
import React, { Component } from 'react';

import { Modal } from './Modal.component';

export class ErrorModal extends Component {
	constructor(props) {
		super(props);

		dompurify.addHook('afterSanitizeAttributes', node => {
			// set all elements owning target to target=_blank
			if ('target' in node) {
				node.setAttribute('target', '_blank');
			}
		});
	}

	/**
	 * `dangerouslySetInnerHTML` is React's replacement for using `innerHtml` in the browser DOM.
	 * It is advised to use cautiously, so we're utilizing `DOMPurify` node package to strengthen
	 * the security. For more information, visit http://jira/browse/WEBAPPS-19690.
	 */
	renderDescription = description => (
		<div
			className="error-modal-body-description"
			data-qa="error-modal-desc"
			{...{ dataqa: 'error-modal-desc' }}
			// eslint-disable-next-line
			dangerouslySetInnerHTML={{
				__html: isString(description) ? dompurify.sanitize(description) : '',
			}}
		/>
	);

	render() {
		const { data, modalId } = this.props;
		const { error = {}, size = 'small' } = data;

		// use data object is error is empty
		const errorData = Object.keys(error).length === 0 ? data : error;

		// build button configs
		const primaryButton = errorData.primaryButtonType && {
			type: errorData.primaryButtonType,
			text: errorData.primaryButtonText,
			onClick: errorData.primaryButtonOnClick,
			dataqa: errorData.primaryButtondataqa,
		};

		const secondaryButton = errorData.secondaryButtonType && {
			type: errorData.secondaryButtonType,
			text: errorData.secondaryButtonText,
			onClick: errorData.secondaryButtonOnClick,
			dataqa: errorData.secondaryButtondataqa,
		};

		const header = errorData.title || `Error ${errorData.code || ''}`;

		return (
			<Modal
				modalId={modalId}
				className="error-modal"
				header={header}
				primaryButton={primaryButton}
				secondaryButton={secondaryButton}
				size={size}
			>
				<div className="error-modal-body">
					{this.renderDescription(errorData.description)}
				</div>
			</Modal>
		);
	}
}
